"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _DatePicker = require("../DatePicker");

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledDatePickers = _styledComponents2.default.div.withConfig({
  displayName: "DateRangePicker__StyledDatePickers",
  componentId: "mgw1t7-0"
})(["display:flex;.date-picker:first-child{margin-right:16px;}"]);

const Label = _styledComponents2.default.div.withConfig({
  displayName: "DateRangePicker__Label",
  componentId: "mgw1t7-1"
})(["", " margin-bottom:8px;font-weight:500;font-size:14px;line-height:22px;"], _styles.defaultBody);

class DateRangePicker extends _react.Component {
  constructor(props) {
    super(props);

    this.onChooseStartDate = (date, startMinDate, startMaxDate) => {
      // disable selecting a date before startMinDate or a date after startMaxDate by manual input
      const isValidStartDate = _moment2.default.isMoment(date) && !(_moment2.default.isMoment(startMinDate) && startMinDate.isAfter(date)) && !(_moment2.default.isMoment(startMaxDate) && startMaxDate.isBefore(date));
      date = isValidStartDate ? date : null;
      this.setState({
        selectedStartDate: date
      });
      this.props.onChooseDate("start_date", date);
    };

    this.onChooseEndDate = (date, endMinDate, endMaxDate) => {
      // disable selecting a date before endMinDate or a date after endMaxDate by manual input
      const isValidEndDate = _moment2.default.isMoment(date) && !(_moment2.default.isMoment(endMinDate) && endMinDate.isAfter(date)) && !(_moment2.default.isMoment(endMaxDate) && endMaxDate.isBefore(date));
      date = isValidEndDate ? date : null;
      this.setState({
        selectedEndDate: date
      });
      this.props.onChooseDate("end_date", date);
    };

    const { startDate, endDate } = props;
    this.state = {
      selectedStartDate: startDate || null,
      selectedEndDate: endDate || null
    };
  }

  componentWillReceiveProps({ startDate, endDate }) {
    this.setState({
      selectedStartDate: startDate || null,
      selectedEndDate: endDate || null
    });
  }

  render() {
    const {
      label,
      minStartDate,
      maxEndDate,
      showTimeSelect,
      dateFormat,
      dataCy
    } = this.props;

    const { selectedStartDate, selectedEndDate } = this.state;

    // if endMaxDate is set to null, we get console errors.
    const maxDateFallback = (0, _moment2.default)("2050-01-01");
    const startMinDate = minStartDate || (0, _moment2.default)("2015-01-01");
    const startMaxDate = maxEndDate || selectedEndDate || maxDateFallback;
    const startMinTime = selectedStartDate && selectedStartDate.isSameOrBefore(startMinDate, "day") ? startMinDate : (0, _moment2.default)().startOf("day");
    const startMaxTime = selectedStartDate && selectedStartDate.isSameOrAfter(startMaxDate, "day") ? startMaxDate : (0, _moment2.default)().endOf("day");

    const endMinDate = selectedStartDate || startMinDate;
    const endMaxDate = maxEndDate || maxDateFallback;
    const endMinTime = selectedEndDate && selectedEndDate.isSameOrBefore(endMinDate, "day") ? endMinDate : (0, _moment2.default)().startOf("day");
    const endMaxTime = (0, _moment2.default)().endOf("day");

    return _react2.default.createElement(
      "div",
      null,
      label && _react2.default.createElement(
        Label,
        null,
        label
      ),
      _react2.default.createElement(
        StyledDatePickers,
        null,
        _react2.default.createElement(_DatePicker2.default, {
          selectsStart: true,
          selectedDate: selectedStartDate,
          minDate: startMinDate,
          maxDate: startMaxDate,
          minTime: startMinTime,
          maxTime: startMaxTime,
          onChooseDate: date => this.onChooseStartDate(date, startMinDate, startMaxDate),
          startDate: selectedStartDate,
          endDate: selectedEndDate,
          showTimeSelect: showTimeSelect,
          dateFormat: dateFormat,
          dataCy: dataCy ? `${dataCy}-start` : undefined
        }),
        _react2.default.createElement(_DatePicker2.default, {
          selectsEnd: true,
          selectedDate: selectedEndDate,
          minDate: endMinDate,
          maxDate: endMaxDate,
          minTime: endMinTime,
          maxTime: endMaxTime,
          onChooseDate: date => this.onChooseEndDate(date, endMinDate, endMaxDate),
          startDate: selectedStartDate,
          endDate: selectedEndDate,
          showTimeSelect: showTimeSelect,
          dateFormat: dateFormat,
          dataCy: dataCy ? `${dataCy}-end` : undefined
        })
      )
    );
  }
}

DateRangePicker.propTypes = {
  /**
   * Must be a moment object
   */
  startDate: _propTypes2.default.instanceOf(_moment2.default),
  /**
   * Must be a moment object
   */
  endDate: _propTypes2.default.instanceOf(_moment2.default),
  label: _propTypes2.default.string,
  onChooseDate: _propTypes2.default.func,
  /**
   * Must be a moment object
   */
  minStartDate: _propTypes2.default.instanceOf(_moment2.default),
  /**
   * Must be a moment object
   */
  maxEndDate: _propTypes2.default.instanceOf(_moment2.default),
  showTimeSelect: _propTypes2.default.bool,
  dateFormat: _propTypes2.default.string,
  dataCy: _propTypes2.default.string
};

DateRangePicker.defaultProps = {
  showTimeSelect: false,
  dateFormat: "ll"
};

exports.default = DateRangePicker;